import React from 'react';
import { contains } from '../../interface';
import ReusableModel from './ReusableModel';

class ModelWrapper extends React.PureComponent {
  state = {
    fetched: false,
    isInBounds: false,
  };

  componentDidMount() {
    this.maybeFetchModel();
  }

  componentDidUpdate(prevProps) {
    const { zoom, minZoom, viewLat, viewLng } = this.props;
    if (
      prevProps.zoom !== zoom ||
      prevProps.minZoom !== minZoom ||
      prevProps.viewLat !== viewLat ||
      prevProps.viewLng !== viewLng
    ) {
      this.maybeFetchModel();
    }
  }

  maybeFetchModel() {
    const { minZoom, zoom } = this.props;
    const { fetched } = this.state;
    if (fetched || typeof minZoom !== 'number' || zoom <= minZoom) {
      return;
    }
    const inBounds = this.checkIfInBounds();
    if (!fetched && inBounds) {
      this.fetchModelFile();
    }
  }

  checkIfInBounds() {
    const { placeIds = [], places } = this.props;
    const isInBounds = placeIds.some((id) => {
      const place = places[id];
      return place && contains(+place.latitude, +place.longitude);
    });
    this.setState({ isInBounds });
    return isInBounds;
  }

  fetchModelFile = () => {
    const { fetchModel, modelId, fileName } = this.props;
    this.setState({ fetched: true });
    fetchModel(modelId, fileName);
  };

  render() {
    const {
      mapId,
      modelBlob,
      modelId,
      places,
      placeIds = [],
      pngTransparencyEnabled,
      settings,
      textures,
      saveUUIDs,
      uuids,
      onPlaceClick,
    } = this.props;

    const models = placeIds.map((placeId) => places[placeId]);

    return (
      <React.Fragment>
        {modelBlob && (
          <ReusableModel
            isInBounds={this.state.isInBounds}
            modelBlob={modelBlob}
            placeIds={placeIds}
            models={models}
            settings={settings}
            textures={textures}
            mapId={mapId}
            modelId={modelId}
            pngTransparencyEnabled={pngTransparencyEnabled}
            saveUUIDs={saveUUIDs}
            uuids={uuids}
            onPlaceClick={onPlaceClick}
          />
        )}
      </React.Fragment>
    );
  }
}

export default ModelWrapper;
